var _defs, _rect, _rect2, _rect3, _circle, _circle2, _ellipse, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacuumPump2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steel",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelDark",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4a545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c333a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a201b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper",
    x1: 0,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c79b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9853f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96501a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperEdge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b06428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3c295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4a16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0dfa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8a83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lcd",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fb37c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shellWhite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eef1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#243021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#161d14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0f0a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0.5,
    cy: 0.46,
    r: 0.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BAE66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 0 L 0 0 0 60",
    fill: "none",
    stroke: "#8BAE66",
    strokeOpacity: 0.07,
    strokeWidth: 1.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#halo)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 318,
    fill: "none",
    stroke: "#8BAE66",
    strokeOpacity: 0.22,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 292,
    fill: "none",
    stroke: "#8BAE66",
    strokeOpacity: 0.1,
    strokeWidth: 16
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 720,
    rx: 250,
    ry: 42,
    fill: "#000000",
    opacity: 0.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 470) scale(0.86) rotate(-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -210,
    y: 120,
    width: 420,
    height: 38,
    rx: 10,
    fill: "url(#graphite)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -190,
    y: 112,
    width: 380,
    height: 14,
    rx: 7,
    fill: "#59654e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -70,
    width: 196,
    height: 190,
    rx: 30,
    fill: "url(#steelDark)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: -56,
    x2: 17.5,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: -56,
    x2: 39,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    y1: -56,
    x2: 60.5,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: -56,
    x2: 82,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.5,
    y1: -56,
    x2: 103.5,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: -56,
    x2: 125,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.5,
    y1: -56,
    x2: 146.5,
    y2: 106,
    stroke: "#0f1512",
    strokeOpacity: 0.3,
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 25,
    r: 60,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 25,
    r: 30,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -196,
    y: -40,
    width: 190,
    height: 160,
    rx: 22,
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -182,
    y: -26,
    width: 120,
    height: 52,
    rx: 10,
    fill: "#2f3d21",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -122,
    cy: 78,
    r: 30,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -122,
    cy: 78,
    r: 21,
    fill: "#f2b705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-143,78 a21,21 0 0 0 42,0 z",
    fill: "#c98a00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -224,
    y: -96,
    width: 52,
    height: 66,
    rx: 10,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -198,
    cy: -104,
    r: 26,
    fill: "url(#steel)",
    stroke: "#5c666d",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -198,
    cy: -104,
    r: 10,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62,-70 L-62,-132 Q-62,-152 -42,-152 L58,-152 Q78,-152 78,-132 L78,-70",
    fill: "none",
    stroke: "#262d24",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42,-152 L58,-152",
    stroke: "#5c6a4c",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 82,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#a3c46f",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 3.08
  }, "Value")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 854,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 0.6,
    textAnchor: "start",
    letterSpacing: 1.04
  }, "Vacuum Pump")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuumPump2);
export default __webpack_public_path__ + "static/media/vacuum-pump-2.67bc593b0f9368a5d7481c454d259ec5.svg";
export { ForwardRef as ReactComponent };